import { LOGO_URL, ARCHIVED_STUDIES, ARCHIVED_STATS } from "./constants";

const fmtInr = (n) =>
  "₹" + Number(n).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const ArchivedResearchCard = ({ study, idx }) => (
  <article
    className="ar-card reveal"
    style={{ transitionDelay: `${idx * 80}ms` }}
    data-testid={`archived-card-${study.symbol.toLowerCase()}`}
  >
    <div className="ar-head">
      <div className="ar-logo" style={{ background: `linear-gradient(135deg, ${study.accent} 0%, rgba(0,0,0,0.4) 100%)` }}>
        <span>{study.monogram}</span>
      </div>
      <div className="ar-head-text">
        <div className="ar-name">{study.name}</div>
        <div className="ar-nse">NSE : {study.symbol}</div>
      </div>
      <div className="ar-status-badge">✓ {study.status}</div>
    </div>

    <div className="ar-roi-row">
      <div className="ar-roi-block">
        <span>Return Since Entry</span>
        <strong>+{study.roi.toFixed(2)}%</strong>
      </div>
      <div className="ar-roi-block">
        <span>P&amp;L / Share</span>
        <strong>+{fmtInr(study.pnl)}</strong>
      </div>
    </div>

    <div className="ar-price-row">
      <div>
        <span>Entry</span>
        <strong>{fmtInr(study.entry)}</strong>
      </div>
      <div>
        <span>Current</span>
        <strong className="ar-price-up">{fmtInr(study.current)}</strong>
      </div>
    </div>

    <div className="ar-levels">
      <div className="ar-level">
        <span>Target 1{study.t1Hit && <em className="ar-tick">✓</em>}</span>
        <strong>{fmtInr(study.target1)}</strong>
      </div>
      <div className="ar-level">
        <span>Target 2{study.t2Hit && <em className="ar-tick">✓</em>}</span>
        <strong>{fmtInr(study.target2)}</strong>
      </div>
      <div className="ar-level ar-level-sl">
        <span>Stop Loss</span>
        <strong>{fmtInr(study.stopLoss)}</strong>
      </div>
    </div>

    <div className="ar-dates">
      <div><span>Added</span><strong>{study.publishedDate}</strong></div>
      <div><span>Completed</span><strong>{study.completedDate}</strong></div>
    </div>

    <button className="ar-view-btn" data-testid={`archived-view-${study.symbol.toLowerCase()}`}>
      View Research →
    </button>
  </article>
);

const ArchivedSectionHead = () => (
  <div className="section-head reveal">
    <img
      src={LOGO_URL}
      alt="KIRA Archives"
      className="archives-logo"
      data-testid="archives-logo"
    />
    <div className="section-eyebrow">Historical Studies</div>
    <h2 className="section-title">
      Archived <span className="gold">Research Studies</span>
    </h2>
    <p className="section-sub">
      Review our historical educational research studies and understand how technical
      and fundamental setups evolved over time. Historical outcomes are displayed
      solely for educational purposes and should not be interpreted as future
      performance or investment advice.
    </p>
  </div>
);

const ArchivedStatsRow = () => (
  <div className="ar-stats-row reveal" data-testid="archived-stats-row">
    {ARCHIVED_STATS.map((s) => (
      <div className="ar-stat" key={s.label} data-testid={`ar-stat-${s.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
        <div className="ar-stat-icon">{s.icon}</div>
        <div className="ar-stat-body">
          <div className="ar-stat-value">{s.value}</div>
          <div className="ar-stat-label">{s.label}</div>
        </div>
      </div>
    ))}
  </div>
);

export const ArchivedResearchSection = ({ onLogin }) => (
  <section id="archived-research" className="archived-section" data-testid="archived-section">
    <ArchivedSectionHead />

    <div className="ar-grid" data-testid="archived-grid">
      {ARCHIVED_STUDIES.map((study, i) => (
        <ArchivedResearchCard key={study.symbol} study={study} idx={i} />
      ))}
    </div>

    <ArchivedStatsRow />

    <div className="ar-cta-row reveal">
      <button
        className="btn btn-gold btn-lg"
        onClick={onLogin}
        data-testid="archived-view-all-btn"
      >
        View All Archived Research →
      </button>
    </div>
  </section>
);
